import Select from "./_selectBox";
import SelectBox from "./_selectBox";



$(function(){
    $(document).on('click', '.p-service__btn-choice--login, .p-service__btn-coupon--login', ()=> promokit.login() );
});

new Select('.p-service__list .select');
if( $('.layer-reward .select').length ) new SelectBox('.layer-reward .select', true);



let layerCoupon = promokit.layer({
    el: '#layer-table',
});

let layerReward = promokit.layer({
    el: '#layer-reward',
    buttons: '.p-service__btn-layer'
});



promokit.store('layerCoupon', layerCoupon);


// WEBPACK FOOTER //
// ./src/js/common.js